import { useEffect, useRef } from "react";
import { useYandexMaps } from "../../hooks/useYandexMaps";

interface MapBlockProps {
  center?: [number, number];
  zoom?: number;
  apiKey: string;
  balloonContent?: string;
}

export const MapBlock = ({
  center = [59.9343, 30.3351],
  zoom = 14,
  apiKey,
  balloonContent = "Санкт-Петербург",
}: MapBlockProps) => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const isReady = useYandexMaps(apiKey);

  useEffect(() => {
    if (!isReady || !mapRef.current) return;

    const map = new window.ymaps.Map(mapRef.current, {
      center,
      zoom,
      controls: ["zoomControl", "fullscreenControl"],
    });

    const placemark = new window.ymaps.Placemark(
      center,
      { balloonContent },
      { preset: "islands#redIcon" }
    );

    map.geoObjects.add(placemark);

    return () => map.destroy();
  }, [isReady, center, zoom, balloonContent]);

  return <div ref={mapRef} className="w-full h-full" />;
};